import React, { Component } from "react";
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Header, Icon, List, Transition } from 'semantic-ui-react';
import { AccountMandateDto, UpsertUserConfigDto } from 'ts-types/api.types';
import { saveUserConfig } from 'services/userConfigServices';
import { RouteComponentProps } from 'react-router';
import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import axios, { CancelTokenSource } from 'axios';
import { noop } from 'utils/functionUtils';
import { withRouterWorkaround } from 'utils/workaroundUtils';

interface Props extends MessageSourceProps, RouteComponentProps<any>, AuthConsumerRenderProps {
  visible: boolean
}

interface state {
  cancelTokenSource: CancelTokenSource
}

class MandatesSegment extends Component<Props, state> {

  constructor(props: Props) {
    super(props);

    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      cancelTokenSource
    }

  }

  setUserConfig = (mandateId: number) => {

    const { history, updateUserConfig, location } = this.props;
    const { from } = location.state || { from: { pathname: '/' } };
    const { cancelTokenSource } = this.state;

    const upsertUserConfig: Partial<UpsertUserConfigDto> = {
      mandateId: mandateId
    };

    saveUserConfig(upsertUserConfig, cancelTokenSource).then(response => {
      updateUserConfig(response);
      history.push(from.pathname);
    }).catch(noop);
  };

  getMandates = () => {
    const { currentUser } = this.props;

    let mappedMandates: Array<JSX.Element> = [];
    if (currentUser) {
      mappedMandates = currentUser.accountMandates
          .map( (accountMandate: AccountMandateDto, index: number) => {
            return (
                <List.Item key={index} onClick={() => this.setUserConfig(accountMandate.id)}>
                  <List.Content>
                    <List.Header as={"h3"}>
                      { accountMandate.name }
                    </List.Header>
                  </List.Content>
                </List.Item>
            );
          });
    }

    return mappedMandates;
  };

  render(): React.ReactNode {

    const { getMessage, visible } = this.props;

    return (
        <Transition animation={"fade left"} duration={400} visible={visible}>
          <div>
            <Header as='h2' icon textAlign='center'>
              <Icon name='user doctor'/>
              {getMessage('login.mandate.text')}
            </Header>
            <List selection verticalAlign='middle' celled>
              {this.getMandates()}
            </List>
          </div>
        </Transition>
    );
  }
}

export default withMessages(withRouterWorkaround(withAuthContext(MandatesSegment)));
